import React from 'react';

//props.setMonth('next')}

export default function NotificationCollapse(props) {
    return (
        <div className="card-header">
            <button
                className="btn btn-primary pull-right"
                type="button"
                data-toggle="collapse"
                data-target="#settingsNotificationCollapse"
                aria-expanded="false"
                aria-controls="settingsNotificationCollapse"
            >
                <span className="if-collapsed">Uitklappen</span>
                <span className="if-not-collapsed">Inklappen</span>
            </button>
            <h4>Notificaties</h4>
        </div>
    );
}